import { render, staticRenderFns } from "./CompanyService.vue?vue&type=template&id=624a1ee4&scoped=true&"
import script from "./CompanyService.vue?vue&type=script&lang=js&"
export * from "./CompanyService.vue?vue&type=script&lang=js&"
import style0 from "./CompanyService.vue?vue&type=style&index=0&id=624a1ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a1ee4",
  null
  
)

export default component.exports